import {
  Paintbrush,
  Wrench,
  Hammer,
  CircleDot,
  Sparkles,
  PaintBucket,
  Droplets,
  ShowerHead,
  Car,
  Star,
  Truck,
  Camera,
  Calendar,
  CalendarDays,
} from "lucide-react";

/**
 * Mapping type -> { icon, color, bg, ring } pour donner une identité
 * visuelle propre à chaque catégorie tout en restant dans la palette PMS.
 */
const TYPE_META = {
  carrosserie_retouche:     { Icon: Paintbrush,   tone: "#b45309", bg: "#fff7ed", ring: "#fed7aa" },
  carrosserie_petit_choc:   { Icon: Wrench,       tone: "#b45309", bg: "#fff7ed", ring: "#fed7aa" },
  debosselage:              { Icon: Hammer,       tone: "#9a3412", bg: "#fff7ed", ring: "#fdba74" },

  reparation_jantes:        { Icon: CircleDot,    tone: "#0f766e", bg: "#f0fdfa", ring: "#99f6e4" },
  renovation_jantes:        { Icon: Sparkles,     tone: "#0f766e", bg: "#f0fdfa", ring: "#99f6e4" },
  peinture_jantes:          { Icon: PaintBucket,  tone: "#115e59", bg: "#ccfbf1", ring: "#5eead4" },

  nettoyage_interieur:      { Icon: Droplets,     tone: "#0369a1", bg: "#f0f9ff", ring: "#bae6fd" },
  nettoyage_exterieur:      { Icon: ShowerHead,   tone: "#0369a1", bg: "#f0f9ff", ring: "#bae6fd" },
  preparation_vehicule:     { Icon: Car,          tone: "#1d4ed8", bg: "#eff6ff", ring: "#bfdbfe" },
  polissage_lustrage:       { Icon: Star,         tone: "#7c3aed", bg: "#f5f3ff", ring: "#ddd6fe" },

  convoyage:                { Icon: Truck,        tone: "#0c4a6e", bg: "#ecfeff", ring: "#a5f3fc" },
  photos_avant_apres:       { Icon: Camera,       tone: "#475569", bg: "#f1f5f9", ring: "#cbd5e1" },
  intervention_journee:     { Icon: Calendar,     tone: "#0f766e", bg: "#f0fdfa", ring: "#99f6e4" },
  intervention_multi_jours: { Icon: CalendarDays, tone: "#0f766e", bg: "#f0fdfa", ring: "#99f6e4" },
};

const FALLBACK = { Icon: Car, tone: "#475569", bg: "#f1f5f9", ring: "#cbd5e1" };

export function getTypeMeta(type) {
  return TYPE_META[type] || FALLBACK;
}

/**
 * Petite icône colorée pour les chips / titres compacts.
 * @param {{ type: string, size?: number }} props
 */
export default function MissionTypeIcon({ type, size = 38, label }) {
  const meta = getTypeMeta(type);
  const { Icon } = meta;
  return (
    <span
      role={label ? "img" : "presentation"}
      aria-label={label}
      style={{
        width: size,
        height: size,
        borderRadius: Math.round(size * 0.32),
        background: meta.bg,
        color: meta.tone,
        border: `1px solid ${meta.ring}`,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      <Icon size={Math.round(size * 0.55)} strokeWidth={2.2} />
    </span>
  );
}
